import api from "@/services/api";

// Golden tickets: códigos al portador de un solo uso para las campañas.
//
// Van en su propio servicio y no colgando de `userService` / `missionService`
// porque en el backend también son su propio modelo y su propio viewset: no
// comparten nada con los códigos promocionales, que son reutilizables.
export default {
  // Público: quien escanea el QR todavía no tiene cuenta, así que la tarjeta
  // tiene que poder saludarlo antes de pedirle nada.
  info(codigo) {
    return api
      .get("golden-tickets/info/", { params: { codigo } })
      .then((response) => response.data);
  },
  // `desde` es el código de OTRO ticket, ya muerto, que esta persona vio
  // antes de conseguir el suyo. Va acá y no en un endpoint aparte porque solo
  // tiene sentido junto al canje, y porque así llega en la misma transacción
  // que lo quema. El backend valida su forma y descarta lo que no calce.
  redeem(codigo, desde) {
    return api
      .post("golden-tickets/redeem/", { codigo, desde: desde || "" })
      .then((response) => response.data);
  },
  // Solo admin. Devuelve un ZIP con un PDF por ticket, así que la respuesta
  // es binaria y hay que pedirla como blob o axios la destroza al parsearla.
  pdfs(codigos) {
    return api
      .post("golden-tickets/pdfs/", { codigos }, { responseType: "blob" })
      .then((response) => response.data);
  },
  // Solo admin. Devuelve los códigos generados.
  createBatch(payload) {
    return api
      .post("golden-tickets/create-batch/", payload)
      .then((response) => response.data);
  },
};
